<template>
  <div class="myTree">
    <div
      v-if="userInfo.user.customerType == 1"
      class="list"
      @click="setActiveList(0)"
    >
      <!-- <router-link to="/user/authentication"> -->
      <div @click="authentication">
        <img
          v-show="activeList === 0"
          class="logo"
          src="@/assets/img/userInfo/rz22.png"
          alt
        />
        <img
          v-show="activeList !== 0"
          class="logo"
          src="@/assets/img/userInfo/rz11.png"
          alt
        />
        <div :class="activeList === 0 ? 'text' : 'defulttText'">认证</div>
        <div class="show"></div>
      </div>
      <!-- </router-link> -->
      <!-- v-if="userInfo.user.customerType && (userInfo.user.customerType == 4 || isSon === 'true')" -->
    </div>
    <div class="list" @click="setActiveList(600)">
      <div @click="to('/user/mytickets')">
        <van-icon
          style="font-weight: 700"
          name="coupon-o"
          size="26"
          :color="activeList === 600 ? '#11117c' : '#78787a'"
        />
        <div :class="activeList === 600 ? 'text' : 'defulttText'">我的门票</div>
        <div class="show"></div>
      </div>
    </div>
    <div v-if="isHot" class="list" @click="setActiveList(700)">
      <div @click="to('/user/zghmrg')">
        <img
          v-show="activeList === 700"
          class="logo"
          src="@/assets/img/userInfo/zghxz.png"
          alt
        />
        <img
          v-show="activeList !== 700"
          class="logo"
          src="@/assets/img/userInfo/zgh.png"
          alt
        />
        <div :class="activeList === 700 ? 'text' : 'defulttText'">征稿函</div>
        <div class="show"></div>
      </div>
    </div>
    <div class="list">
      <!--      @click="setActiveList(100)"-->
      <div>
        <img
          alt
          v-show="activeList !== 100"
          class="logo"
          src="@/assets/img/userInfo/nrgl.png"
        />
        <img
          alt
          v-show="activeList === 100"
          class="logo"
          src="@/assets/img/userInfo/nr.png"
        />
        <div
          @click="changeBlock('contentBlock')"
          :class="activeList === 100 ? 'text' : 'defulttText'"
        >
          内容管理
        </div>
        <img
          @click="changeBlock('contentBlock')"
          :class="contentBlock ? 'show' : 'fShow'"
          src="@/assets/img/userInfo/1.png"
          alt
        />
      </div>
      <ul
        :style="{
          height: contentBlock ? topList.length * 40 + 20 + 'px' : '0px',
        }"
        class="block"
      >
        <li
          v-for="(item, index) in topList"
          :key="index"
          :class="active === item.id? 'act' : ''"
          @click="setActiveList(100, item.id)"
        >
          <span @click="to(item.vuePath)">{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <div class="list">
      <div>
        <img
          v-show="activeList !== 200"
          class="logo"
          src="@/assets/img/userInfo/xx.png"
          alt
        />
        <img
          v-show="activeList === 200"
          class="logo"
          src="@/assets/img/userInfo/xx2.png"
          alt
        />
        <div
          @click="changeBlock('msgBlock')"
          :class="activeList === 200 ? 'text' : 'defulttText'"
        >
          消息
        </div>
        <img
          @click="changeBlock('msgBlock')"
          :class="msgBlock ? 'show' : 'fShow'"
          src="@/assets/img/userInfo/1.png"
          alt
        />
      </div>
      <ul :style="{ height: msgBlock ? '40px' : '0px' }" class="block">
        <li
          v-for="(item, index) in msgList"
          :key="index"
          :class="active === 200 + index + 1 ? 'act' : ''"
          @click="setActiveList(200, 200 + index + 1)"
        >
          <span @click="to(item.vuePath)">{{ item.name }}</span>
        </li>
      </ul>
      <!--      <ul :style="{ height: msgBlock ? '40px' : '0px' }" class="block">-->
      <!--        <li-->
      <!--          :class="active === 201 ? 'act' : ''"-->
      <!--          @click="setActiveList(200, 201)"-->
      <!--        >-->
      <!--          <span @click="to('/user/msg')">系统通知</span>-->
      <!--        </li>-->
      <!--  -->
      <!--      </ul>-->
      <!--      </router-link>-->
    </div>

    <div class="list">
      <!--      <router-link to="/user/setting">-->
      <!--      @click="setActiveList(300)"-->
      <div>
        <img
          v-show="activeList !== 300"
          class="logo"
          src="@/assets/img/userInfo/sz.png"
          alt
        />
        <img
          v-show="activeList === 300"
          class="logo"
          src="@/assets/img/userInfo/sz2.png"
          alt
        />
        <div
          @click="changeBlock('setBlock')"
          :class="activeList === 300 ? 'text' : 'defulttText'"
        >
          设置
        </div>
        <img
          @click="changeBlock('setBlock')"
          :class="setBlock ? 'show' : 'fShow'"
          src="@/assets/img/userInfo/1.png"
          alt
        />
      </div>

      <ul
        :style="{ height: setBlock ? setList.length * 40 + 20 + 'px' : '0px' }"
        class="block"
      >
        <!--        {{// setList}}-->
        <li
          v-for="(item, index) in setList"
          :key="index"
          :class="active === 300 + index + 1 ? 'act' : ''"
          @click="setActiveList(300, 300 + index + 1)"
        >
          <span @click="to(item.vuePath)">{{ item.name }}</span>
        </li>
      </ul>
      <!--      <ul-->
      <!--        :style="{-->
      <!--          height: setBlock ? (isSon !== 'true' ? '100px' : '40px') : '0px',-->
      <!--        }"-->
      <!--        class="block"-->
      <!--      >-->
      <!--        <li-->
      <!--          :class="active === 301 ? 'act' : ''"-->
      <!--          @click="setActiveList(300, 301)"-->
      <!--        >-->
      <!--          <span @click="to('/user/setting')">账号设置</span>-->
      <!--        </li>-->
      <!--        <li-->
      <!--          v-if="isSon !== 'true'"-->
      <!--          :class="active === 302 ? 'act' : ''"-->
      <!--          @click="setActiveList(300, 302)"-->
      <!--        >-->
      <!--          <span-->
      <!--            v-if="-->
      <!--              userInfo.user.customerType === 1 ||-->
      <!--              userInfo.user.customerType === 2 ||-->
      <!--              userInfo.user.customerType === 3-->
      <!--            "-->
      <!--            @click="to('/user/scholar')"-->
      <!--          >学者信息</span-->
      <!--          >-->
      <!--          <span-->
      <!--            @click="to('/user/magazine')"-->
      <!--            v-if="userInfo.user.customerType === 4"-->
      <!--          >期刊信息</span-->
      <!--          >-->
      <!--          <span-->
      <!--            @click="to('/user/organization')"-->
      <!--            v-if="userInfo.user.customerType === 5"-->
      <!--          >机构信息</span-->
      <!--          >-->
      <!--        </li>-->
      <!--        <li-->
      <!--          v-if="-->
      <!--            userInfo.user.customerType === 5 || userInfo.user.customerType === 4-->
      <!--          "-->
      <!--          :class="active === 303 ? 'act' : ''"-->
      <!--          @click="setActiveList(300, 303)"-->
      <!--        >-->
      <!--          <span @click="to('/user/sonUser')">子账号设置</span>-->
      <!--        </li>-->
      <!--      </ul>-->
      <!--      </router-link>-->
    </div>
    <div class="list">
      <!--      <router-link to="/user/history">-->
      <div @click="setActiveList(400)">
        <img
          v-show="activeList !== 400"
          class="logo"
          src="@/assets/img/userInfo/lsjs.png"
          alt
        />
        <img
          v-show="activeList === 400"
          class="logo"
          src="@/assets/img/userInfo/lsjs2.png"
          alt
        />
        <div
          @click="to('/user/history')"
          :class="activeList === 400 ? 'text' : 'defulttText'"
        >
          历史记录
        </div>
        <div class="show"></div>
      </div>
      <!--      </router-link>-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "myTree",
  data() {
    return {
      contentBlock: true,
      msgBlock: true,
      setBlock: true,
      activeList: 600,
      active: null,
      isSon: "false",
      sonZgh: false,
      topList: [],
      setList: [],
      msgList: [],
    };
  },
  created() {
    this.isSon = sessionStorage.getItem("isSon");
    this.activeList = this.userInfo.user.customerType == 1 ? 0 : this.activeList
    this.lookPage();
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    isHot() {
      let i = this.userInfo.user.customerType == 4;
      let arr = [];
      this.userInfo.permissionUrls[0].forEach((item) => {
        arr.push(item.name);
      });
      let j = arr.indexOf("征稿函") !== -1;
      return i || j;
    },
  },
  watch: {
    "$route.path": {
      handler(newUrl) {
        switch (newUrl) {
          case "/user/contentMrg":
            this.to("/user/contentMrg");
            this.setActiveList(100, 4);
            break;
          case "/user/messageMrg":
            this.setActiveList(100, 5);
            this.to("/user/messageMrg");
            break;
          case "/user/zghmrg":
            this.setActiveList(700);
            this.to("/user/zghmrg");
            break;
          case "/user/meetMan":
            this.setActiveList(100,69);
            this.to("/user/meetMan");
            break;
          case "/user/courseMan":
            this.setActiveList(100,72);
            this.to("/user/courseMan");
            break;
          default:
            break;
        }
      },
      immediate: true,
    },
  },
  methods: {
    authentication() {
      let userHasData = JSON.parse(sessionStorage.getItem("userHasData"));
      if (userHasData.status == 0 || userHasData.status == 2) {
        this.$router.push("/user/review");
      } else {
        this.$router.push("/user");
      }
    },
    changeBlock(e) {
      this[e] = !this[e];
    },
    lookPage() {
      this.topList = this.userInfo.permissionUrls["2"];
      if (this.isSon === "true") {
        this.topList = this.topList.filter((item) => {
          if (item.name === "征稿函") {
            this.sonZgh = true;
          } else {
            return item;
          }
        });
        this.msgList = [
          {
            name: "系统通知",
            vuePath: "/user/msg",
          },
        ];
        this.setList = [
          {
            name: "账号设置",
            vuePath: "/user/setting",
          },
        ];
        return;
      }
      if (this.userInfo.user.customerType === 1) {
        this.msgList = [
          {
            name: "系统通知",
            vuePath: "/user/msg",
          },
        ];
        this.setList = [
          {
            name: "账号设置",
            vuePath: "/user/setting",
          },
        ];
      } else if (
        this.userInfo.user.customerType === 3 ||
        this.userInfo.user.customerType === 2
      ) {
        this.msgList = [
          {
            name: "系统通知",
            vuePath: "/user/msg",
          },
        ];
        this.setList = [
          {
            name: "账号设置",
            vuePath: "/user/setting",
          },
          {
            name: "学者信息",
            vuePath: "/user/scholar",
          },
        ];
        // this.historyList = [
        //   {
        //     name: "浏览历史",
        //     vuePath: "/user/scholar"
        //   }
        // ]
      } else if (this.userInfo.user.customerType === 4) {
        this.msgList = [
          {
            name: "系统通知",
            vuePath: "/user/msg",
          },
        ];
        this.setList = [
          {
            name: "账号设置",
            vuePath: "/user/setting",
          },
          {
            name: "期刊信息",
            vuePath: "/user/magazine",
          },
          {
            name: "子账号设置",
            vuePath: "/user/sonUser",
          },
        ];
      } else if (this.userInfo.user.customerType === 5) {
        this.msgList = [
          {
            name: "系统通知",
            vuePath: "/user/msg",
          },
        ];
        this.setList = [
          {
            name: "账号设置",
            vuePath: "/user/setting",
          },
          {
            name: "机构信息",
            vuePath: "/user/organization",
          },
          {
            name: "子账号设置",
            vuePath: "/user/sonUser",
          },
        ];
        // this.navList = ["全部", "期刊论文", "文摘", "行业报告", "科技报告"];
      }
    },
    //使用router——link会出现莫名选中样式应该是被哪里污染了
    to(url) {
      this.$router.push(url);
    },
    setActiveList(num, act) {
      this.activeList = num;
      act ? (this.active = act) : (this.active = num + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.myTree {
  // margin-top: 54px;
  margin-left: 0;

  .list {
    cursor: pointer;
    // margin-top: 0;

    margin-bottom: 40px;
    width: 200px;

    .block {
      overflow: hidden;
      width: 200px;
      transition: height 0.5s;

      .act {
        color: #0b35c5;
      }

      li {
        // background-color: #222;
        text-align: left;
        width: 120px;
        margin: 15px auto;
        // height: 18px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        // line-height: 24px;
      }
    }

    div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .show {
        width: 19px;

        height: 10px;
        opacity: 0.4;
      }

      .fShow {
        width: 19px;
        transform: rotate(180deg);
        height: 10px;
        opacity: 0.4;
      }

      .logo {
        width: 22px;
        height: 22px;
      }

      .defulttText {
        width: 120px;
        text-align: left;
        font-size: 22px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }

      .text {
        width: 120px;
        text-align: left;
        font-size: 22px;
        font-weight: bold;
        color: #11117c;
        line-height: 24px;
      }
    }
  }
}
</style>
